import { FastLayer, Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';
import {useScroll} from '../arrangement/useScroll.js';
import AutomationPoint from './AutomationPoint.js';
import {setAutomationGuidePoint} from 'actions/index.js';
import { connect } from "react-redux";
import React, {useReducer, memo, useState, useCallback, useEffect} from 'react';
import {
    getStepFromXPosition,
    getValueFromYPosition,
    getYForParameter} from './position.js';
import {getLinePoints} from './getLinePoints.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

window.otherColor = '#637475';

const LinePoints = memo(({
    isMix,
    automation,
    track,
    sequencerEngine,
    automations,
    pointHovered, 
    pointsSelected=[],
    pointDragging,
    xScale,
    color,
    height,
    selectedParameter,
    setGuidePoint,
    wrapperRef,
    width}) => {
        let _automations = automations || [];
        _automations.forEach(
            (pt, i) => pt.duration =_automations[i+1] ? _automations[i+1].step - pt.step : 1);

        let {visibleView} = useScroll(
            {
                ref: wrapperRef,
                events: _automations,
                xScale,
                resolution: sequencerEngine.state.sequencer.resolution,
                sequencerEngine,
                eventsLength: _automations.length
            });
        if (visibleView.start) {
            _automations = _automations.slice(visibleView.start, visibleView.end);
        }
        let linePoints = 
            getLinePoints({width, height, selectedParameter, xScale, events: _automations});
      
        const onMouseOver = useCallback((e) => {
            let x = isMix ? e.clientX - 140 : e.clientX - 56;
            x += wrapperRef.current.scrollLeft;
            let y = e.clientY;

            let step = getStepFromXPosition(x, xScale, width);
            let value = getValueFromYPosition(
                y,
                height,
                selectedParameter.min,
                selectedParameter.max);

            setGuidePoint({step, value});

        }, [setGuidePoint, selectedParameter, height, xScale]);

        return [(
              <polyline
                strokeWidth={2}
                points={linePoints.join(",")}
                stroke={'red'}
              />),
            ..._automations.map(
                  pt =>
                      <AutomationPoint
                        key={"automation-" + pt.id}
                        sequencerEngine={sequencerEngine}
                        operationManager={sequencerEngine.operationManager}
                        track={track}
                        isHovered={pointHovered === pt}
                        isDragging={pointDragging && pointDragging.id === pt.id}
                        automation={automation}
                        width={width}
                        isSelected={pointsSelected.some(p => pt.id === p.id)}
                        point={pt}
                        height={height}
                        xScale={xScale}
                        selectedParameter={selectedParameter}
                      />
            )];
    });

const mapDispatchToProps = (dispatch, props) => {
    return {
        setGuidePoint: (pt) => dispatch(setAutomationGuidePoint(props.track.id, pt))
    };
};

const mapStateToProps = (state, props) => {
    let selectedParameter = props.selectedParameter;
    let engineId = selectedParameter && selectedParameter.sequencerEngine.sequenceId;
    let engineAutomations = props.isMix ?
        state.automation.parameterMixAutomations[engineId] :
        state.automation.parameterAutomations[engineId];
    let {track} = props;
    return {
        automations: selectedParameter && engineAutomations ? engineAutomations[selectedParameter.id] : undefined,
        pointHovered: state.automation.pointHovered[track.id],
        pointDragging : state.automation.pointDragging[track.id],
        pointsSelected: state.automation.pointsSelected[track.id]
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(LinePoints);



